<template>
  <div class="about-mm">
    <section class="about" color-primary>
      <p>一网通网上支付是招商银行提供的网上即时付款服务。通过一网通网上支付，您可以在网上任意选购众多与招商银行签约的特约商户所提供的商品，足不出户，即可进行网上消费。</p>
      <p>根据协议您使用ETC设备需要绑定<span color-red-tip>3年</span>一网通免密支付，若您中途解绑需要<span color-red-tip>缴纳180元违约金</span>。且解绑后此ETC设备会因无法正常支付被列入高速联网黑名单。</p>
      <p>若您解绑后一年内在此页面再次进行签约一网通免密支付，则180元会原路返还。</p>
    </section>
    <section class="about-bottom">
      <button cool-btn-hollow @click="unbind">解绑免密支付</button>
      <button cool-btn>绑定一网通免密支付</button>
      <div class="fixed-bottom"></div>
    </section>
    <popup ref="popup" class="about-popup">
      <div slot="content" class="popup-container">
        <header>提示</header>
        <div class="popup-content">
          <!--三年内-->
          <p>解绑设备需缴纳180元违约金 <br>（支付成功后会自动进行解绑）</p>
          <p textalign-left>绑定成功，您之前缴纳的违约金将会原路返还。具体到账时间以银行通知为准。你的设备会在24小时后正常使用。</p>
          <!--三年后-->
          <p>您确定解绑一网通免密支付吗？</p>
          <p textalign-left>绑定成功后，你的设备会在24小时后正常使用。</p>
        </div>
        <div class="popup-footer">
          <button cool-btn @click="clickPopBtn">确定</button>
        </div>
      </div>
    </popup>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// components
import Popup from '@/components/cool.popup'

export default {
  name: 'aboutMM',
  mixins: [FunMixin],
  components: {
    Popup
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    unbind() {
      this.$refs.popup.$emit('showPopup', {closeBtn: true})
    },
    clickPopBtn() {
      this.$refs.popup.$emit('hidePopup')
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
.about-mm{
  padding: 50px 40px;
  .about{
    background-color: #F2F9F2;
    border-radius: 10px;
    padding: 10px 40px 30px;
    font-size: 24px;
    line-height: 40px;
    p{
      margin-top: 20px;
    }
  }
  .about-bottom{
    position: fixed;
    bottom: 30px;
    left: 0;
    width: 100%;
    padding: 0 55px;
  }
  .about-popup{
    .popup-container{
      header{
        padding-top: 50px;
        text-align: center;
        font-size: 36px;
        font-weight: bold;
      }
      .popup-content{
        font-size: 30px;
        color: #666666;
        line-height: 42px;
        text-align: center;
        padding: 40px 50px 0;
      }
      .popup-footer{
        padding: 40px 85px;
        [cool-btn]{
          line-height: 80px;
        }
      }
    }
  }
}
</style>
